<form [formGroup]="textFg">
  <div>
    <snelstart-ui-textarea-form-control formControlName="toelichtingNietUitDeBalansBlijkendeVerplichtingen"
                                        class="me-1 custom-input-800"
                                        label="Omschrijving"
                                        [rows]="5"
                                        (change)="saveForm()"
    >
    </snelstart-ui-textarea-form-control>
  </div>
</form>
